export const idToString = (id) => {
  if (id && (typeof id === 'string' || typeof id === 'number')) {
    return id.toString();
  } else {
    return '';
  }
};

export const convertMonetaryValueToNumber = (money) => {
  if (money && typeof money === 'string') {
    return parseInt(money.split(',').join(''));
  }
  if (money && typeof money === 'number') {
    return money;
  }
  return 0;
};

export const toInt = (target) => {
  const result = parseInt(target);
  if (isNaN(result)) return '';
  return result;
};

export const createTrackReplayer = ({ target, time }) => {
  target.tryCount = target.tryCount === undefined ? 0 : target.tryCount;
  target.time = target.time === undefined ? time : target.time;
  return (event, data) => {
    if (target.time > 0 && target.ready !== true) {
      target.time--;
      target.tryCount++;
      setTimeout(() => {
        if (target.track) {
          target.track(event, data);
        }
      }, 1000 * Math.pow(2, target.tryCount - 1));
      return;
    }
  };
};

export const bindCallbackToElement = ({ element, callback, event }) => {
  if (element === 'window') {
    window.addEventListener(event, callback);
  } else {
    if (typeof element === 'string') {
      document.querySelector(element).addEventListener(event, callback);
    }
    if (element.nodeType) {
      element.addEventListener(event, callback);
    }
  }
};
